import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

import styles from "./Auth.module.scss";

import logo from "../../Assets/images/teneelogo.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{
          zIndex: "9",
          // backgroundImage:'../../Assets/images/authBg.png',
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: "99999",
          background: "#ddd",
          height: "50                                ",
        }}
      >
        <Container className="">
          <Row className="justify-content-center">
            <Col lg="6" md="6" sm="8" className="my-2 py-4 h-100">
              <div
                className={`${styles.formWrpper} formWrpper position-relative px-3 py-4`}
                // style={{ height: "85vh" }}
              >
                <div className="d-flex justify-content-center">
                  <div className="logo-wrapper text-center pb-lg-1 pb-1">
                    <img
                      src={logo}
                      alt=""
                      className="img-fluid object-fit-contain"
                      style={{ height: 100 }}
                    />
                  </div>
                </div>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
